import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { BOOKINGS } from "@/constants/testIds";
import { toast, Toaster } from "sonner";
import { Check, X, Clock } from "lucide-react";

const STATUSES = ["pending", "confirmed", "completed", "cancelled"];

export default function Bookings() {
  const [rows, setRows] = useState([]);

  const load = async () => {
    try {
      const { data } = await api.get("/bookings");
      setRows(data.bookings);
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  useEffect(() => {
    load();
  }, []);

  const changeStatus = async (id, status) => {
    try {
      await api.patch(`/bookings/${id}`, { status });
      toast.success("Updated");
      load();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  return (
    <div data-testid={BOOKINGS.container} className="p-10">
      <Toaster position="top-right" richColors />
      <div className="mb-8">
        <div className="overline mb-3">AI agent output</div>
        <h1 className="font-display text-4xl font-black tracking-tighter">
          Bookings captured
        </h1>
        <p className="text-neutral-500 mt-2 max-w-xl">
          Every appointment your AI agents have collected from visitors on
          the generated preview websites.
        </p>
      </div>

      <div className="bg-white border border-neutral-200 overflow-x-auto">
        {rows.length === 0 ? (
          <div className="p-12 text-center text-neutral-500 text-sm">
            <Clock className="w-8 h-8 mx-auto mb-2 text-neutral-300" />
            No bookings yet. Create an agent and share the preview site — it'll
            collect appointments 24/7.
          </div>
        ) : (
          <table className="lf-grid">
            <thead>
              <tr>
                <th>Contact</th>
                <th>Business</th>
                <th>Service</th>
                <th>Preferred time</th>
                <th>Status</th>
                <th>Captured</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} data-testid={BOOKINGS.row(r.id)}>
                  <td>
                    <div className="font-semibold">{r.name}</div>
                    <div className="text-xs font-mono text-neutral-500">
                      {r.phone}
                    </div>
                  </td>
                  <td>{r.lead_name}</td>
                  <td className="text-neutral-700">{r.service}</td>
                  <td className="text-neutral-700">{r.preferred_time}</td>
                  <td>
                    <select
                      value={r.status}
                      onChange={(e) => changeStatus(r.id, e.target.value)}
                      className="px-2 py-1 border border-neutral-300 text-xs bg-white"
                    >
                      {STATUSES.map((s) => (
                        <option key={s} value={s}>
                          {s}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td className="text-neutral-500 text-xs">
                    {new Date(r.created_at).toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
